import { DataSecurityAppUser } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAppUsersByAppIdRequest = {
	applicationId: number;
	filter?: string;
};

export const getDataSecurityAppUsersByAppId =
	createGetEndpoint<GetDataSecurityAppUsersByAppIdRequest, Array<DataSecurityAppUser>>(
		(request) => `/api/v3/data-security/applications/${request.applicationId}/salesforce-users?${getQueryString(
			{
				filter: request.filter
			}
		)}`
	);
